import React from "react";
import { Link } from "react-router-dom";
import Layout from "./../components/Layout/Layout";

const Pagenotfound = () => {
    return (
        <Layout>
            <div className="pnf">
                <img src="https://img.freepik.com/free-vector/404-error-with-people-holding-numbers-concept-illustration_114360-7903.jpg?w=1060&t=st=1677048042~exp=1677048642~hmac=de6ba8b0018a74d14392910fc1e69ae74d26cbac67372aba426d6f4c22beb63c" alt="" />
                {/* <h1 className="pnf-title">404</h1>
                <h2 className="pnf-heading">Oops ! Page Not Found</h2> */}
                <Link to="/" className="pnf-btn">
                    Go Back
                </Link>
            </div>
        </Layout>
    );
};

export default Pagenotfound;